// @core/api/endpoints/platform/list_consent_records.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListConsentRecordsResponse,
} from '../../../types/platform';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/platform';

/**
 * List consent records
 * Returns all consent records for the current user across all federation peers.
 */
export async function ListConsentRecords(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListConsentRecordsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/federation/consent`;
  const requestOptions = options;
  return client.get<ListConsentRecordsResponse>(requestPath, { ...requestOptions, params });
}
